<template>
<div class="msg-group" ref="msg-group" tabindex="1">
  <h1 class="uploading" v-if="uploadProgress">Uploading...</h1>
  <div class="msg-item myself" v-if="uploadProgress">
    <div class="img-item">
      <img class="box-img" :src="uploadProgress.imageURL" />
    </div>
  </div>
  <!-- {{ roomID }} -->
  <div class="msg-item" :ref="'msg_' + msg._id" :key="msg._id" v-for="msg in sortedMsgs()" :class="{ 'myself': isMe(msg), 'others': !isMe(msg) }">
    <Replier class="margin-bottom" :msgs="sortedMsgs()" @view-reply="(v) => { $emit('view-reply', v); scrollToView(v); }" :msg="msg"  />
    <div class="msg-block" tabindex="-1">
      <div class="label">
        <div v-if="msg.type === 'text'">
          <TextMsg :msg="msg"></TextMsg>
        </div>
        <div v-if="msg.type === 'poll'">
          <Poll :roomPW="roomPW" :isRoomAdminLoggedIn="isRoomAdminLoggedIn" :msg="msg"></Poll>
        </div>
        <div v-if="msg.type === 'latex'">
          <Latex :msg="msg"></Latex>
        </div>
        <div class="img-item" v-if="msg.type === 'img' || msg.type === 'image'">
          <ImageMsg :msg="msg" @remix="(v) => { $emit('remix', v) }"></ImageMsg>
        </div>
        <Footer class="msg-footer" aria-hidden="true" @toCHI="toCHI" @reply="(v) => { $emit('reply', { reply: v.reply, msgs: msgs }) }" @room="(v) => { $emit('room', v) }" :room="room" :msg="msg" :roomPW="roomPW" :isRoomAdminLoggedIn="isRoomAdminLoggedIn" :isAdmin="isAdmin()" />
      </div>
    </div>
  </div>

  <!-- <pre>{{ msgs }}</pre> -->
</div>
</template>

<script>
import { Status, API } from '../index.js'
import TextMsg from './TextMsg.vue'
import ImageMsg from './ImageMsg.vue'
import Footer from './Footer.vue'
import Replier from './Replier.vue'
import Poll from './Poll.vue'
import Latex from './Latex.vue'

export default {
  components: {
    TextMsg,
    ImageMsg,
    Footer,
    Replier,
    Poll,
    Latex
  },
  props: {
    flipMsg: {},
    uploadProgress: {},
    roomPW: {},
    isRoomAdminLoggedIn: {
      default: false
    },
    room: {
      default () {
        return false
      }
    },
    roomID: {
      default () {
        return this.$route.params.roomID
      }
    }
  },
  data () {
    return {
      // room: false,
      msgs: []
    }
  },
  methods: {
    toCHI ({ msg }) {
      // API.translateMessage({
      //   text: msg.text,
      //   toLang: 'zh-TW'
      // }).then((resp) => {
      //   msg.text = resp.data.text
      //   console.log(resp.data)
      // })
    },
    scrollToView ({ msg }) {
      let child = (this.$refs['msg_' + msg.parentID] || [])[0]
      let group = this.$refs['msg-group']
      console.log(child)
      if (child) {
        var topPos = group.offsetTop
        group.scrollTop = child.offsetTop - topPos
        // this.$refs['msg-group'].scrollTop = 0
      }
    },
    sortedMsgs () {
      let ans = []
      if (this.room && this.room.sortMethod === 'chat') {
        ans = this.msgs.slice().sort((a, b) => {
          if (a.isPinned) {
            return -1
          } else {
            return 0
          }
        })
      } else {
        ans = this.msgs.slice().sort((a, b) => {
          if (a.isPinned) {
            return -1
          }

          let dA = a.voteUpUUID.length
          let dB = b.voteUpUUID.length
          if (dA > dB) {
            return -1
          } else if (dA === dB) {
            if (Date.parse(a.date) > Date.parse(b.date)) {
              return -1
            } else if (Date.parse(a.date) < Date.parse(b.date)) {
              return 1
            }

            return 0
          } else {
            return 1
          }
        })
      }
      if (this.flipMsg) {
        ans = ans.slice().reverse()
      }
      return ans
    },
    isMe (msg) {
      return Status.state.chatter && msg.senderUUID === Status.state.chatter.uuid
    },
    isAdmin () {
      return this.room && Status.state.chatter && this.room.adminUUIDs.includes(Status.state.chatter.uuid)
    }
  },
  mounted () {
    API.onChangeOnlineCounter({
      roomID: this.roomID,
      onChange: (data) => {
        console.log(data)
      }
    })
    API.checkOnline({ roomID: this.roomID })
    // console.log(API.Status.state.chatter)
    API.joinKeepRoom({
      roomID: this.roomID,
      nickname: API.Status.state.chatter.name,
      deviceID: API.Status.state.chatter.uuid
    })

    API.onRoomChange({
      roomID: this.roomID,
      update: (data) => {
        this.$emit('room', data)
      },
      goHome: () => {
        this.$router.push('/')
      },
      onClearRoom: () => {
        API.listSomeLatest({ roomID: this.roomID })
          .then((resp) => {
            this.msgs = resp.data
          })
      }
    })
    API.onMessageChange({
      roomID: this.roomID,
      add: (data) => {
        if (!this.msgs.map(m => m._id).includes(data._id)) {
          this.msgs.unshift(data)
          this.$forceUpdate()
          if (this.flipMsg) {
            setTimeout(() => {
              let group = this.$refs['msg-group']
              if (group) {
                group.scrollTop = group.scrollHeight
              }
            }, 100)
          }
        }
      },
      remove: (data) => {
        if (this.msgs.map(m => m._id).includes(data._id)) {
          this.msgs.splice(this.msgs.findIndex(m => m._id === data._id), 1)
          this.$forceUpdate()
        }
      },
      update: (data) => {
        console.log(data)
        if (this.msgs.map(m => m._id).includes(data._id)) {
          let idx = this.msgs.findIndex(m => m._id === data._id)
          this.msgs[idx] = data
          this.$forceUpdate()
        }
      },
      goLogin: () => {
        this.$emit('go-login')
      }
    })
    API.listSomeLatest({ roomID: this.roomID })
      .then((resp) => {
        this.msgs = resp.data
        // this.$refs['msg-group'].setAttribute('tabindex', 0)
        this.$refs['msg-group'].focus()
      })
  }
}
</script>

<style scoped>
.myself{
  text-align: left;
  background: #f7fffb;
  border-radius: 16px;
  box-shadow: #d2fae7 0px 7px 20px 0px;
  border: #b6fada solid 1px;
}
.others{
  text-align: left;
  border-radius: 16px;
  background: #f7fcff;
  box-shadow: #dcf2ff 0px 7px 20px 0px;
  border: #c6eaff solid 1px;
}
.msg-group{
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.msg-item{
  max-width: 80%;
  min-width: 50%;
  margin: 14px;
  padding: 10px;
}
.msg-item.myself{
  align-self: flex-end;
}
.msg-item.others{
  align-self: flex-start;
}
.img-item{
  max-height: 500px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-img{
  border-radius: 9px;
  width: 100%;
}
.uploading{
  text-align: center;
  color: #c6303e;
}

.msg-block{
  background-color: rgba(255, 255, 255, 0.575);
  border: rgba(151, 151, 151, 0.575) solid 1px;
  border-radius: 5px;
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
}
.msg-block .label{
  padding-left: 10px;
}
.margin-bottom{
  margin-bottom: 10px;
}

@media print {
  .msg-item.myself{
    border: none;
    box-shadow: none;
    margin: 7px;
  }
  .msg-item.others{
    border: none;
    box-shadow: none;
    margin: 7px;
  }
}

</style>
